export default {
  deliveryOrders: [], //state for callback DO
  deliveryById : [],
  massDeliveryorders : []
}
